import { DashboardPage } from '../../dashboard/DashboardPage';
import { FormControlGroup } from '../../input/FormControlGroup';
import { BusinessRegistrationHeader } from '../BusinessRegistrationHeader/BusinessRegistrationHeader';
import { BusinessType } from '../types';
import { BLOGGER_ACCOUNT_TEXT, BUSINESS_ACCOUNT_TEXT, SERVICE_ACCOUNT_TEXT } from './constants';
import { BusinessRegistrationAccountControl } from './parts/BusinessRegistrationAccountControl/BusinessRegistrationAccountControl';
import { Wrapper } from './styles';
import { BusinessRegistrationAccountProps } from './types';

export const BusinessRegistrationAccount = ({
    type,
    onChange,
}: BusinessRegistrationAccountProps) => (
    <DashboardPage mt={{ sm: 2 }}>
        <Wrapper>
            <BusinessRegistrationHeader
                typeSlot={
                    <FormControlGroup mt={2} width="100%" spacing={1} onChange={onChange}>
                        <BusinessRegistrationAccountControl
                            {...BUSINESS_ACCOUNT_TEXT}
                            value={BusinessType.BUSINESS}
                            checked={type === BusinessType.BUSINESS}
                            onChange={onChange}
                        />
                        <BusinessRegistrationAccountControl
                            {...SERVICE_ACCOUNT_TEXT}
                            value={BusinessType.SERVICE}
                            checked={type === BusinessType.SERVICE}
                            onChange={onChange}
                        />
                        <BusinessRegistrationAccountControl
                            {...BLOGGER_ACCOUNT_TEXT}
                            value={BusinessType.BLOGGER}
                            checked={type === BusinessType.BLOGGER}
                            onChange={onChange}
                        />
                    </FormControlGroup>
                }
            />
        </Wrapper>
    </DashboardPage>
);
